
import storage from "./storage";

export const getUrl = (bizKey) => {
    const UICOMPONENT = get()
    let url = ''
    UICOMPONENT.map( item => {
        if(item.bizKey == bizKey) {
            url = item.url
        }
    })
    return url
}

export const get = () => {
    const UICOMPONENT = storage.getCache('UICOMPONENT');
    return UICOMPONENT ? UICOMPONENT : {}
}